<ng-container *ngComponentOutlet="lpCmpMap[lpSettings.config.layoutType]"></ng-container>
